import React, { ReactElement, useState } from 'react';

interface Props {
    title: string;
    closeTitle?: string;
    children?: React.ReactNode;
}

function CardToggle({ title, closeTitle, children }: Props): ReactElement {
    const [isOpen, setIsOpen] = useState(false);
    const closeTitleString = closeTitle || title;

    return (
        <div className="flex flex-col items-start">
            <button
                className="text-ce-gray-500 text-xxs font-bold px-3.5 py-2 w-full text-left"
                type="button"
                onClick={() => setIsOpen((o) => !o)}
            >
                {isOpen ? closeTitleString : title}
            </button>
            {isOpen && children}
        </div>
    );
}

export default CardToggle;
